import { ReactElement } from 'react';
import classNames from 'classnames/bind';

import { Image, Text } from 'libComponents';

import styles from './StartPageCard.module.css';

import { ReactComponent as CheckMark } from './img/Checkmark.svg';

const cx = classNames.bind(styles);

interface IStartPageCard {
    dataLocator: string;
    onClick: () => void;
    img: string;
    title: string;
    buttonColor?: string;
    withoutCheck?: boolean;
    value?: string;
}

function StartPageCard({
    dataLocator,
    onClick,
    img,
    title,
    buttonColor,
    withoutCheck,
    value,
}: IStartPageCard): ReactElement {
    const buttonStyles = cx('buttonBox', {
        decorativeMale: buttonColor === 'decorativeMale',
    });

    return (
        <button onClick={onClick} data-locator={dataLocator} className={styles.card} value={value}>
            <div className={styles.imageWrapper}>
                <Image src={img} alt="body" />
            </div>
            <div className={buttonStyles}>
                <Text type="small-button" color="text-main">
                    {title}
                </Text>
                {withoutCheck ? null : <CheckMark />}
            </div>
        </button>
    );
}

export default StartPageCard;
